<script setup>
import { computed } from 'vue'
import Icon from '@/Shared/Icon.vue'

const props = defineProps({
  person: {
    type: Object,
    required: true
  },
  nameField: {
    type: String,
    default: 'name'
  },
  lastnameField: {
    type: String,
    default: 'lastname'
  },
  phoneField: {
    type: String,
    default: 'phone'
  },
  badge: {
    type: Object,
    default: () => null
  },
  role: {
    type: String,
    default: ''
  },
  editUrl: {
    type: String,
    required: true
  }
})

const initials = computed(() => {
  const name = props.person[props.nameField] || ''
  const lastname = props.person[props.lastnameField] || ''
  return `${name.charAt(0).toUpperCase()}${lastname.charAt(0).toUpperCase()}`
})

const fullName = computed(() => {
  const name = props.person[props.nameField] || ''
  const lastname = props.person[props.lastnameField] || ''
  return `${name} ${lastname}`
})

const phone = computed(() => {
  return props.person[props.phoneField] || ''
})
</script>

<template>
  <div
    class="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden transition-all duration-300 hover:shadow-md hover:border-indigo-300 cursor-pointer"
    @click="$inertia.visit(editUrl)"
  >
    <!-- Cabecera de la tarjeta -->
    <div class="p-5 border-b border-gray-100 flex justify-between items-center">
      <div class="flex items-center space-x-3">
        <!-- Avatar -->
        <div
          class="bg-indigo-100 text-indigo-700 rounded-full h-10 w-10 flex items-center justify-center font-bold"
        >
          {{ initials }}
        </div>
        <!-- Nombre y apellidos -->
        <div>
          <h3 class="font-semibold text-gray-900">{{ fullName }}</h3>
          <div class="text-sm text-gray-500 flex items-center">
            <Icon name="Phone" class="h-3.5 w-3.5 mr-1" />
            {{ phone }}
          </div>
        </div>
      </div>
      <!-- Insignia -->
      <span
        v-if="badge && badge.show && (badge.text || badge.icon)"
        :class="[
          'inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium',
          badge.class || 'bg-indigo-100 text-indigo-800'
        ]"
      >
        <Icon v-if="badge.icon" :name="badge.icon" class="h-3.5 w-3.5 mr-1" />
        {{ badge.text }}
      </span>
    </div>

    <!-- Pie de la tarjeta -->
    <div class="p-5 flex justify-between items-center">
      <div class="text-sm text-gray-500">
        {{ role }}
      </div>
      <button
        class="inline-flex items-center text-indigo-600 hover:text-indigo-800 font-medium text-sm transition-colors"
      >
        <span>Editar</span>
        <Icon name="Pencil" class="h-4 w-4 ml-1" />
      </button>
    </div>
  </div>
</template>
